// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__TcNzF","container":"styles_container__kVsR_","slide":"styles_slide__FseGQ"};